import { RootRoutes } from './RootRoutes';
import { useRoutes } from 'react-router-dom';

export const RootLayout: React.FC = () => {
  const routes = useRoutes(RootRoutes);

  return <>{routes}</>;
};
